export enum DateFormat {
  FullDateCalendar = 'DD/MM/YYYY',
  FullDateAndTime = 'DD/MM/YYYY HH:mm:ss'
}

export enum TimeFormat {
  HoursAndMinutes = 'HH:mm'
}
